/* eslint-disable import/no-extraneous-dependencies */
import { applyMiddleware, combineReducers, createStore } from 'redux';
import createSagaMiddleware from 'redux-saga';
import { composeWithDevTools } from 'redux-devtools-extension';
import { enableES5 } from 'immer';
import rootSaga from './rootSaga';
import { VisibilityAction } from './visibility/visibilityActions';
import { visibilityReducer, VisibilityState } from './visibility/visibilityReducer';
import { CloseModalAction } from './closeModal/closeModalActions';
import { closeModalReducer, CloseModalState } from './closeModal/closeModalReducer';
import { confirmationModalAction } from './confirmationModal/confirmationModalActions';
import { confirmationModalReducer, confirmationModalState } from './confirmationModal/confirmationModalReducer';
import { formReducer, FormState, getFormLoading } from './form/formReducer';
import { FormAction } from './form/formActions';

enableES5(); // Loading ES5 plugin for IE11

export type RootAction =
  | VisibilityAction
  | CloseModalAction
  | FormAction
  | confirmationModalAction;

export interface RootState {
  visibility: VisibilityState;
  closeModal: CloseModalState;
  confirmationModal: confirmationModalState;
  formState: FormState;
}

export const rootReducer = combineReducers<RootState>({
  visibility: visibilityReducer,
  closeModal: closeModalReducer,
  confirmationModal: confirmationModalReducer,
  formState: formReducer,
});

const sagaMiddleware = createSagaMiddleware();

const configureStore = () => {
  const store = createStore(rootReducer, applyMiddleware(sagaMiddleware));

  sagaMiddleware.run(rootSaga);

  return store;
};

export default configureStore;
